// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global reset for all elements */
* {
	margin: 0;
	padding: 0;
}

/* Styling for the navbar */
.navbar {
	display: flex;
	align-items: center;
	justify-content: center;
	position: sticky;
	top: 0;
	cursor: pointer;
}

/* Background styling */
.background {
	background: rgb(255, 255, 255);
	background-blend-mode: darken;
	background-size: cover;
}

/* Footer styling */
.footer {
	background-color: #000;
}

/* Styling for the navigation list */
.nav-list {
	width: 70%;
	display: flex;
	align-items: center;
}

/* Styling for the logo */
.logo {
	display: flex;
	justify-content: center;
	align-items: center;
}

/* Styling for the logo image */
.logo img {
	width: 180px;
	border-radius: 50px;
}

/* Styling for list items in navigation */
.nav-list li {
	list-style: none;
	padding: 26px 30px;
}

/* Styling for navigation links */
.nav-list li a {
	text-decoration: none;
	color: #000;
}

/* Hover effect for navigation links */
.nav-list li a:hover {
	color: grey;
}

/* Styling for right-aligned navigation items */
.rightnav {
	width: 30%;
	text-align: right;
}

/* Styling for search input */
#search {
	padding: 5px;
	font-size: 17px;
	border: 2px solid rgb(0, 0, 0);
	border-radius: 9px;
}

/* Main box styling */
.box-main {
	display: flex;
	justify-content: center;
	align-items: center;
	color: black;
	max-width: 80%;
	margin: auto;
	height: 80%;
}

/* Styling for the first half of the main box */
.firsthalf {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

/* Styling for the second half of the main box */
.secondhalf {
	width: 30%;
}

/* Styling for images in the second half */
.secondhalf img {
	width: 70%;
	border: 4px solid white;
	border-radius: 150px;
	display: block;
	margin: auto;
}

/* Styling for large text */
.text-big {
	font-weight: 500;
	font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
	font-size: 30px;
}

/* Styling for small text */
.text-small {
	font-size: 18px;
}

/* Styling for buttons */
.btn {
	margin-left: 20px;
	height: 33px;
	width: 70px;
	color: #fff;
	background-color: #000;
	cursor: pointer;
}

/* Styling for small buttons */
.btn-sm {
	padding: 6px 10px;
	vertical-align: middle;
}

/* Styling for sections */
.section {
	height: 200px;
	display: flex;
	align-items: center;
	background-color: rgb(250, 250, 250);
	justify-content: space-between;
}

/* Additional styling for left-aligned sections */
.section-Left {
	flex-direction: row-reverse;
}

/* Center alignment for text */
.center {
	text-align: center;
}

/* Styling for footer text */
.text-footer {
	text-align: center;
	padding: 30px 0;
	font-family: "Ubuntu", sans-serif;
	display: flex;
	justify-content: center;
	color: #fff;
}

/* Default styling for the body */
body {
	font-family: Arial, sans-serif;
	color: #333;
	line-height: 1.6;
}

/* Styling for heading 1 */
h1 {
	color: #000;
}

.app-container {
    transition: opacity 1s ease-in-out;
    opacity: 0;
}

.app-container.loaded {
    opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;CACC,SAAS;CACT,UAAU;AACX;;AAEA,2BAA2B;AAC3B;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,MAAM;CACN,eAAe;AAChB;;AAEA,uBAAuB;AACvB;CACC,8BAA8B;CAC9B,6BAA6B;CAC7B,sBAAsB;AACvB;;AAEA,mBAAmB;AACnB;CACC,sBAAsB;AACvB;;AAEA,oCAAoC;AACpC;CACC,UAAU;CACV,aAAa;CACb,mBAAmB;AACpB;;AAEA,yBAAyB;AACzB;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA,+BAA+B;AAC/B;CACC,YAAY;CACZ,mBAAmB;AACpB;;AAEA,yCAAyC;AACzC;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA,iCAAiC;AACjC;CACC,qBAAqB;CACrB,WAAW;AACZ;;AAEA,sCAAsC;AACtC;CACC,WAAW;AACZ;;AAEA,+CAA+C;AAC/C;CACC,UAAU;CACV,iBAAiB;AAClB;;AAEA,6BAA6B;AAC7B;CACC,YAAY;CACZ,eAAe;CACf,8BAA8B;CAC9B,kBAAkB;AACnB;;AAEA,qBAAqB;AACrB;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;CACZ,cAAc;CACd,YAAY;CACZ,WAAW;AACZ;;AAEA,+CAA+C;AAC/C;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA,gDAAgD;AAChD;CACC,UAAU;AACX;;AAEA,0CAA0C;AAC1C;CACC,UAAU;CACV,uBAAuB;CACvB,oBAAoB;CACpB,cAAc;CACd,YAAY;AACb;;AAEA,2BAA2B;AAC3B;CACC,gBAAgB;CAChB,4DAA4D;CAC5D,eAAe;AAChB;;AAEA,2BAA2B;AAC3B;CACC,eAAe;AAChB;;AAEA,wBAAwB;AACxB;CACC,iBAAiB;CACjB,YAAY;CACZ,WAAW;CACX,WAAW;CACX,sBAAsB;CACtB,eAAe;AAChB;;AAEA,8BAA8B;AAC9B;CACC,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA,yBAAyB;AACzB;CACC,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,oCAAoC;CACpC,8BAA8B;AAC/B;;AAEA,iDAAiD;AACjD;CACC,2BAA2B;AAC5B;;AAEA,8BAA8B;AAC9B;CACC,kBAAkB;AACnB;;AAEA,4BAA4B;AAC5B;CACC,kBAAkB;CAClB,eAAe;CACf,iCAAiC;CACjC,aAAa;CACb,uBAAuB;CACvB,WAAW;AACZ;;AAEA,iCAAiC;AACjC;CACC,8BAA8B;CAC9B,WAAW;CACX,gBAAgB;AACjB;;AAEA,0BAA0B;AAC1B;CACC,WAAW;AACZ;;AAEA;IACI,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,UAAU;AACd","sourcesContent":["/* Global reset for all elements */\n* {\n\tmargin: 0;\n\tpadding: 0;\n}\n\n/* Styling for the navbar */\n.navbar {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: sticky;\n\ttop: 0;\n\tcursor: pointer;\n}\n\n/* Background styling */\n.background {\n\tbackground: rgb(255, 255, 255);\n\tbackground-blend-mode: darken;\n\tbackground-size: cover;\n}\n\n/* Footer styling */\n.footer {\n\tbackground-color: #000;\n}\n\n/* Styling for the navigation list */\n.nav-list {\n\twidth: 70%;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n/* Styling for the logo */\n.logo {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n/* Styling for the logo image */\n.logo img {\n\twidth: 180px;\n\tborder-radius: 50px;\n}\n\n/* Styling for list items in navigation */\n.nav-list li {\n\tlist-style: none;\n\tpadding: 26px 30px;\n}\n\n/* Styling for navigation links */\n.nav-list li a {\n\ttext-decoration: none;\n\tcolor: #000;\n}\n\n/* Hover effect for navigation links */\n.nav-list li a:hover {\n\tcolor: grey;\n}\n\n/* Styling for right-aligned navigation items */\n.rightnav {\n\twidth: 30%;\n\ttext-align: right;\n}\n\n/* Styling for search input */\n#search {\n\tpadding: 5px;\n\tfont-size: 17px;\n\tborder: 2px solid rgb(0, 0, 0);\n\tborder-radius: 9px;\n}\n\n/* Main box styling */\n.box-main {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: black;\n\tmax-width: 80%;\n\tmargin: auto;\n\theight: 80%;\n}\n\n/* Styling for the first half of the main box */\n.firsthalf {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n\n/* Styling for the second half of the main box */\n.secondhalf {\n\twidth: 30%;\n}\n\n/* Styling for images in the second half */\n.secondhalf img {\n\twidth: 70%;\n\tborder: 4px solid white;\n\tborder-radius: 150px;\n\tdisplay: block;\n\tmargin: auto;\n}\n\n/* Styling for large text */\n.text-big {\n\tfont-weight: 500;\n\tfont-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n\tfont-size: 30px;\n}\n\n/* Styling for small text */\n.text-small {\n\tfont-size: 18px;\n}\n\n/* Styling for buttons */\n.btn {\n\tmargin-left: 20px;\n\theight: 33px;\n\twidth: 70px;\n\tcolor: #fff;\n\tbackground-color: #000;\n\tcursor: pointer;\n}\n\n/* Styling for small buttons */\n.btn-sm {\n\tpadding: 6px 10px;\n\tvertical-align: middle;\n}\n\n/* Styling for sections */\n.section {\n\theight: 200px;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: rgb(250, 250, 250);\n\tjustify-content: space-between;\n}\n\n/* Additional styling for left-aligned sections */\n.section-Left {\n\tflex-direction: row-reverse;\n}\n\n/* Center alignment for text */\n.center {\n\ttext-align: center;\n}\n\n/* Styling for footer text */\n.text-footer {\n\ttext-align: center;\n\tpadding: 30px 0;\n\tfont-family: \"Ubuntu\", sans-serif;\n\tdisplay: flex;\n\tjustify-content: center;\n\tcolor: #fff;\n}\n\n/* Default styling for the body */\nbody {\n\tfont-family: Arial, sans-serif;\n\tcolor: #333;\n\tline-height: 1.6;\n}\n\n/* Styling for heading 1 */\nh1 {\n\tcolor: #000;\n}\n\n.app-container {\n    transition: opacity 1s ease-in-out;\n    opacity: 0;\n}\n\n.app-container.loaded {\n    opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
